import {
  FETCH_ACTION_HISTORY_LIST,
  RESET_ACTION_HISTORY_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

const actionHistoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTION_HISTORY_LIST:
      return { list: action.payload, others: action.others };
      // return { list: action.payload, others: { ...state.others} };
    case RESET_ACTION_HISTORY_LIST:
      return initialState;
    default:
      return state;
  }
};

export default actionHistoryListReducer;
